// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyConfiguration {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, registry) {
        var _a, _b;
        this.tabbedNavigation = model.tabbed;
        this.storybookError = (_a = model.storybookEmbedErrorMessage) !== null && _a !== void 0 ? _a : null;
        this.packageJson = (_b = model.renderCodePackageJson) !== null && _b !== void 0 ? _b : null;
        this.isPublic = model.isPublic;
        this.isPrivate = model.isPrivate;
        this.isHidden = model.isHidden;
        this.host = model.host;
        this.selectedBrandId = model.selectedBrandId;
        this.serveDefaultVersionOnly = model.serveDefaultVersionOnly;
        this.npmRegistry = registry !== null && registry !== void 0 ? registry : null;
    }
    toConfigurationModelWriteObject() {
        return {
            tabbed: this.tabbedNavigation,
            // @ts-expect-error TS(2322): Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
            storybookEmbedErrorMessage: this.storybookError,
            // @ts-expect-error TS(2322): Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
            renderCodePackageJson: this.packageJson,
            isPublic: this.isPublic,
            serveDefaultVersionOnly: this.serveDefaultVersionOnly,
            selectedBrandId: this.selectedBrandId,
            host: this.host,
        };
    }
}
